import { createPortal } from "react-dom";
import { X } from "lucide-react";

export default function Modal({ show, onClose, title, children }) {
  if (!show) return null;

  return createPortal(
    <div className="fixed inset-0 h-screen w-screen bg-black bg-opacity-50 z-[9999] flex items-center justify-center">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg w-full max-w-lg p-6 relative overflow-y-auto max-h-full">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-[#171D1B] dark:text-white">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
            aria-label="Close modal"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );
}
